import { testimonials } from "../data";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import SectionHeader from "../components/SectionHeader";

export default function Testimonials() {
  return (
    <>
      <PageHero
        eyebrow="Testimonials"
        title="What clients feel after they visit."
        desc="Stories from bridal clients, regular clients, spa clients, academy graduates, and nail clients."
        image="https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=1700&auto=format&fit=crop&q=76"
      />

      <section className="section-pad dark-section">
        <div className="container">
          <Reveal>
            <SectionHeader eyebrow="Stories" title="Real words from Orchid clients." />
          </Reveal>
          <div className="testimonial-grid all">
            {testimonials.map((item, index) => (
              <Reveal delay={index * 70} key={item.name}>
                <article className={`testi-card bits-spotlight ${index === 1 ? "featured" : ""}`}>
                  <div className="quote">"</div>
                  <p>{item.text}</p>
                  <div className="testi-author">
                    <div className="avatar">{item.avatar}</div>
                    <div><strong>{item.name}</strong><em>{item.role}</em></div>
                  </div>
                  <span className="rating">{item.rating} rating</span>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
